import { useState } from "react";
import { X } from "lucide-react";

const SECTORS = [
  "Industrial", "Commercial", "IT", "Educational", "Government", "Institutional",
  "Healthcare", "Hospitality", "Showroom", "Residential", "General",
];

const EMPTY = {
  name: "", client: "", location: "", sector: "Industrial", scope: "",
  status: "ongoing", group: "current", featured: false,
};

export default function ProjectModal({ initial, onClose, onSave }) {
  const [form, setForm] = useState(initial ? { ...EMPTY, ...initial } : EMPTY);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const isEdit = Boolean(initial?.id);

  const set = (k) => (e) => {
    const v = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((f) => ({ ...f, [k]: v }));
  };

  const save = async () => {
    if (!form.name.trim()) { setErr("Project name is required."); return; }
    setBusy(true);
    setErr("");
    try {
      await onSave(form);
    } catch (e) {
      setErr(e.response?.data?.detail || "Could not save project.");
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" onMouseDown={onClose}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()} data-testid="project-modal">
        <div className="modal-head">
          <h3>{isEdit ? "Edit Project" : "Add Project"}</h3>
          <button className="icon-btn" onClick={onClose} data-testid="modal-close"><X /></button>
        </div>
        <div className="modal-body">
          {err && <div className="login-error">{err}</div>}
          <div className="field">
            <label>Project Name *</label>
            <input value={form.name} onChange={set("name")} placeholder="e.g. EMMVEE Energy Pvt Ltd" data-testid="field-name" />
          </div>
          <div className="field row2">
            <div className="field">
              <label>Client</label>
              <input value={form.client} onChange={set("client")} placeholder="Client name" data-testid="field-client" />
            </div>
            <div className="field">
              <label>Location</label>
              <input value={form.location} onChange={set("location")} placeholder="City / area" data-testid="field-location" />
            </div>
          </div>
          <div className="field row2">
            <div className="field">
              <label>Status</label>
              <select value={form.status} onChange={set("status")} data-testid="field-status">
                <option value="ongoing">Ongoing</option>
                <option value="completed">Completed</option>
              </select>
            </div>
            <div className="field">
              <label>Group</label>
              <select value={form.group} onChange={set("group")} data-testid="field-group">
                <option value="current">Current (SUV Engineers)</option>
                <option value="legacy">Legacy (partner companies)</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label>Sector</label>
            <select value={form.sector} onChange={set("sector")} data-testid="field-sector">
              {SECTORS.includes(form.sector) ? null : <option value={form.sector}>{form.sector}</option>}
              {SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Scope of Work</label>
            <textarea rows="3" value={form.scope} onChange={set("scope")} placeholder="Short description of work delivered" data-testid="field-scope" />
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 10, fontWeight: 700, fontSize: "0.9rem" }}>
            <input type="checkbox" checked={form.featured} onChange={set("featured")} style={{ width: 18, height: 18 }} data-testid="field-featured" />
            Feature this project
          </label>
        </div>
        <div className="modal-foot">
          <button className="btn btn-ghost btn-sm" style={{ color: "var(--ink)", borderColor: "var(--line)", background: "#fff" }} onClick={onClose}>Cancel</button>
          <button className="btn btn-primary btn-sm" onClick={save} disabled={busy} data-testid="modal-save">
            {busy ? "Saving…" : isEdit ? "Save Changes" : "Add Project"}
          </button>
        </div>
      </div>
    </div>
  );
}
